
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'admin': `Administration`,
'admin.menu.audit': `Journaux d'audit`,
'admin.menu.directory-auth': `Authentification d'annuaire`,
'admin.menu.identity-providers': `Fournisseurs d'identité et d'authentification`,
'admin.menu.ip-allowlist': `Liste d'autorisation IP`,
'admin.menu.organization-settings': `Paramètres de l'organisation`,
'admin.menu.roles': `Rôles`,
'admin.menu.scim-tokens': `Jetons SCIM`,
'admin.menu.site-admin': `Administration du site`,
'admin.menu.site-admin.create': `Créer un site`,
'admin.menu.user-groups': `Groupes d'utilisateurs`,
'admin.menu.users': `Gestion des utilisateurs`,
'admin.menu.workload-identities': `Identités de charge de travail`,
'ai-coworkers.menu.agents.deployment': `Déploiement`,
'ai-coworkers.menu.agents.events': `Événements`,
'ai-coworkers.menu.control': `Protection`,
'ai-coworkers.menu.control.exceptions': `Demandes d'exception`,
'ai-coworkers.menu.control.policies': `Politiques`,
'ai-coworkers.menu.control.yara-rules': `Règles YARA`,
'ai-coworkers.menu.dashboards': `Tableau de bord`,
'ai-coworkers.menu.intelligence': `Renseignements`,
'ai-coworkers.menu.intelligence.coding-sessions': `Sessions IA`,
'ai-coworkers.menu.inventory': `Visibilité`,
'ai-coworkers.menu.inventory.agent-skills': `Compétences des agents`,
'ai-coworkers.menu.inventory.agents': `Agents IA`,
'ai-coworkers.menu.inventory.endpoints': `Endpoints`,
'ai-coworkers.menu.inventory.mcp-servers': `Serveurs MCP`,
'ai-coworkers.menu.inventory.model-endpoints': `Endpoints LLM`,
'ai-coworkers.menu.settings': `Paramètres`,
'ai-coworkers.menu.settings.administration': `Administration`,
'ai-coworkers.menu.settings.connectors': `Connecteurs`,
'ai-coworkers.menu.settings.license': `Licence et utilisation`,
'ai-coworkers.menu.settings.update-strategy': `Stratégie de mise à jour`,
'analytics': `Analyses`,
'appliance': `Appliance`,
'auditing': `Audit`,
'breadcrumbNavLabel': `Fil d'Ariane`,
'breadcrumbOverflowLabel': `Afficher plus d'éléments de navigation`,
'computer-groups': `Groupes d'ordinateurs`,
'computers': `Ordinateurs`,
'configuration': `Configuration`,
'dashboard': `Dashboards`,
'downloads': `Consoles et téléchargements`,
'entitle.menu.accessReview': `Vue d'ensemble`,
'entitle.menu.auditLogs': `Journaux d'audit`,
'entitle.menu.bundles': `Ensembles`,
'entitle.menu.identityGraph': `Autorisations`,
'entitle.menu.integrations': `Intégrations`,
'entitle.menu.policies': `Politiques de droits innés`,
'entitle.menu.profile': `Mes paramètres`,
'entitle.menu.requests': `Demandes`,
'entitle.menu.requestsLog': `Historique des demandes`,
'entitle.menu.settings': `Paramètres d'organisation`,
'entitle.menu.tasks': `Tâches`,
'entitle.menu.users': `Utilisateurs`,
'entitle.menu.workflows': `Flux d'approbation`,
'epml.menu.audit': `Audit`,
'epml.menu.consoleAccess': `Accès à la console`,
'epml.menu.consoleAudit': `Audit de la console`,
'epml.menu.directoryServices': `Services d'annuaire`,
'epml.menu.endpoints': `Gestion des endpoints`,
'epml.menu.epmlSettings': `Paramètres EPML`,
'epml.menu.events': `Événements`,
'epml.menu.explore': `Explorer`,
'epml.menu.installers': `Programmes d'installation`,
'epml.menu.linuxHostAuth': `Authentification de l'hôte Linux`,
'epml.menu.policy': `Politique`,
'epml.menu.roles': `Rôles`,
'epml.menu.searchAndReplay': `Recherche et relecture`,
'epml.menu.settings': `Paramètres`,
'epml.menu.siemConnections': `Connexions SIEM`,
'epml.menu.unifiedSearch': `Recherche unifiée`,
'home': `Accueil`,
'insights.menu.accounts': `Comptes`,
'insights.menu.agentInventory': `Inventaire des agents`,
'insights.menu.aiAgents': `Agents IA`,
'insights.menu.aiSecurity': `Sécurité IA`,
'insights.menu.aiThreatDetection': `Détection des menaces`,
'insights.menu.aiThreatPolicy': `Politique de menaces`,
'insights.menu.connectors': `Connecteurs`,
'insights.menu.dashboard': `Dashboard`,
'insights.menu.detections': `Détections`,
'insights.menu.entitlements': `Droits d'accès`,
'insights.menu.exclusionRules': `Règles d'exclusion`,
'insights.menu.identities': `Identités`,
'insights.menu.identitiesPrivileges': `Identités et privilèges`,
'insights.menu.insights': `Insights`,
'insights.menu.integrations': `Intégrations`,
'insights.menu.integrationsConnections': `Intégrations et connexions`,
'insights.menu.recommendations': `Recommandations`,
'insights.menu.reporting': `Rapports`,
'insights.menu.secrets': `Secrets`,
'insights.menu.secretsInventory': `Inventaire des secrets`,
'insights.menu.secretsSecurity': `Sécurité des secrets`,
'jit-access-management': `Gestion d'accès JIT`,
'jump': `Asset Management`,
'localization': `Localisation`,
'login.account_policy.index': `Politiques de comptes`,
'login.api_account.index': `Configuration API`,
'login.appliance.index': `Appliance`,
'login.business_hours.index': `Horaires`,
'login.callback_button.index': `Boutons de support`,
'login.canned_message.index': `Messages prédéfinis`,
'login.canned_script.index': `Scripts prédéfinis`,
'login.compliance.index': `Conformité`,
'login.custom_fields.index': `Champs personnalisés`,
'login.custom_links.index': `Liens personnalisés`,
'login.customer_notice.index': `Avis clients`,
'login.dashboard.getNetworkRestrictions': `Restrictions réseau`,
'login.dashboard.index': `Dashboards`,
'login.discovery.index': `Découverte`,
'login.downloads.drivers.index': `Pilotes`,
'login.downloads.rep.index': `Rep Console`,
'login.duplicate_pinned_clients_reporting.index': `Jump Clients en double`,
'login.email_settings.index': `Configuration des e-mails`,
'login.endpoint_automation.index': `Automatisation des endpoints`,
'login.exit_survey.index': `Enquêtes de sortie`,
'login.file_store.index': `Stockage de fichiers`,
'login.group_policy.index': `Politiques de groupe`,
'login.html_template.index': `Modèles HTML`,
'login.ios_profile.index': `Configuration iOS`,
'login.issue.index': `Problèmes`,
'login.jump_item_reporting.index': `Asset`,
'login.jump_item_roles.index': `Asset Roles`,
'login.jump_item.index': `Assets`,
'login.jump_policies.index': `Asset Policies`,
'login.kerberos_keytab.index': `Kerberos Keytab`,
'login.license_reporting.index': `Licences`,
'login.licensing.index': `Licences`,
'login.mcp_config.index': `Serveur MCP`,
'login.ms_teams.index': `MS Teams`,
'login.my_account.profile.index': `Profil`,
'login.my_account.security.index': `Sécurité`,
'login.nls.real_time_chat.index': `Chat en temps réel`,
'login.outbound_event.index': `Événements sortants`,
'login.pinned_clients.index': `Jump Clients`,
'login.public_site.index': `Sites publics`,
'login.push_agent.index': `Gateway`,
'login.rep_invite.index': `Invitation de représentant`,
'login.rep_profile.index': `Paramètres de Rep Console`,
'login.sd_client.index': `Client de support`,
'login.sd_general.index': `Options`,
'login.security_providers.index': `Fournisseurs de sécurité`,
'login.security_settings.index': `Sécurité`,
'login.session_policy.index': `Politiques de session`,
'login.session_report.index': `Support`,
'login.settings.index': `Logiciel`,
'login.shared_jump_groups.index': `Asset Groups`,
'login.site_settings.index': `Configuration du site`,
'login.skill.index': `Compétences`,
'login.special_action.index': `Actions spéciales`,
'login.status_representatives.index': `Représentants`,
'login.status.index': `Informations`,
'login.support_settings.index': `Support`,
'login.syslog_reporting.index': `Syslog`,
'login.team.index': `Équipes de support`,
'login.user.index': `Utilisateurs`,
'login.vault_account_group.index': `Groupes de comptes`,
'login.vault_account.index': `Comptes`,
'login.vault_domain.index': `Domaines`,
'login.vault_endpoint.index': `Endpoints`,
'login.vault_options.index': `Options`,
'login.vault_password_safe_connection.index': `Connexions`,
'login.vault_reporting.index': `Coffre-fort`,
'management': `Gestion`,
'management-rules': `Règles de gestion`,
'menu-phantom-labs': `Phantom Labs`,
'my_account': `Mon compte`,
'pmc.audit': `Audit`,
'pmc.explore': `Explorer`,
'pmc.settings': `Paramètres`,
'policies': `Politiques`,
'public_site': `Portails publics`,
'rep_console': `Paramètres de la console`,
'reporting': `Rapports`,
's352719d86112de9a': `Aide`,
's3741f519c32ac391': `Nouveau`,
's3d64ea063be4c9f2': `Audit unifié`,
's416434bef0c17abc': `Impossible de charger le menu. Fermez-le, puis rouvrez-le pour réessayer.`,
's417b90913e05bc17': `Aperçu`,
's49730f3d5751a433': `Chargement...`,
's4c9351ce0cc28196': `Navigation des produits`,
's596a144afb429d94': `Plus de produits`,
's5e8250fb85d64c23': `Fermer`,
's691d6163aaabb69b': `Profil utilisateur`,
's6abb1cd87fe0114e': `Accueil`,
's6d8c02aee480af7a': `Menu`,
's714ea1e6436002a2': `Garder la navigation épinglée`,
's76902262e33e63b5': `Afficher ou masquer la navigation latérale`,
'sd': `Configuration`,
'sffe2914d4b7c91ee': `Accès anticipé`,
'sitemenu.about': `À propos`,
'sitemenu.analytics': `Analyses et rapports`,
'sitemenu.analyticsandreporting.viewallreports': `Voir tous les rapports`,
'sitemenu.analyticsandreportingtrident': `Analyses et rapports`,
'sitemenu.assets': `Actifs`,
'sitemenu.configuration': `Configuration`,
'sitemenu.dashboard': `Dashboard`,
'sitemenu.dashboard.dynamicdashboard': `Dashboard (Aperçu)`,
'sitemenu.discovery': `Découverte`,
'sitemenu.discovery.activeandcompletedscans': `Analyses actives/terminées`,
'sitemenu.discovery.discoveryscanners': `Scanners de découverte`,
'sitemenu.discovery.newdiscoveryscan': `Exécuter une nouvelle analyse de découverte`,
'sitemenu.discovery.scheduledscans': `Analyses planifiées`,
'sitemenu.managedaccounts': `Comptes gérés`,
'sitemenu.managedsystems': `Systèmes gérés`,
'sitemenu.passwordsafe': `Password Safe`,
'sitemenu.passwordsafe.accounts': `Comptes`,
'sitemenu.passwordsafe.activesessions': `Sessions actives`,
'sitemenu.passwordsafe.administratorsessions': `Sessions d'administration`,
'sitemenu.passwordsafe.approvals': `Approbations`,
'sitemenu.passwordsafe.completedsessions': `Sessions terminées`,
'sitemenu.smartrules': `Règles intelligentes`,
'sitemenu.teampasswords': `Secrets Safe`,
'siteSelectorDataResidency': `résidence des données`,
'siteSelectorLabel': `Site`,
'siteSelectorNoSitesFound': `Aucun site trouvé`,
'siteSelectorSearchPlaceholder': `Rechercher des sites`,
'status': `État`,
'user-management': `Gestion des utilisateurs`,
'users': `Utilisateurs et sécurité`,
'vault': `Coffre-fort`,
    };
  